import React, { useState, useContext, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import useSystemAlertTable from "./useSystemAlertTable.js";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import UserService from "services/UserService";
import { deleteSystemAlert } from "services/ConfigServices";
//import "react-table/react-table.css";
import Dialog from "@mui/material/Dialog";
import { systemalertstext } from "variables/MBM/systemalerts.js";
import { criticityData, closedData } from "variables/MBM/lists/systemalerts";
import { withStyles } from "@mui/styles";
// @mui/icons-material
import Tooltip from '@mui/material/Tooltip';
import styled from "styled-components";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CommentsDialog from "./CommentsDialog.js";
import AcquitmentDialog from "./AcquitmentDialog.js";

const useStyles = makeStyles(styles);
const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);


const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const RTSystemAlerts = () => {
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;
  const { setPage } = appContext;
  const { gridState, refetch, setAlerts } = useSystemAlertTable();
  const [currentAlert, setCurrentAlert] = useState();
  const [commentOpen, setCommentOpen] = useState(false);
  const [acquitmentOpen, setAcquitmentOpen] = useState(false);

  useEffect(() => {
    setPage('systemalerts');
  }, []);


  let dataAlerts = gridState.data;


  const columns = [
    {
      name: systemalertstext.starttimestamp,
      selector: row => row.starttimestamp,
      sortable: true,
      width: "10rem",
      cell: (row) => moment(row.starttimestamp).format("YYYY-MM-DD HH:mm"),
    },
    {
      name: systemalertstext.endtimestamp,
      selector: row => row.endtimestamp ? row.endtimestamp : 0,
      sortable: true,
      width: "10rem",
      cell: (row) =>
        row.endtimestamp ?
          moment(row.endtimestamp).format("YYYY-MM-DD HH:mm")
          : <></>
    },
    {
      name: systemalertstext.osgroup,
      selector: row => groupInfoListById["" + row.osgroup] || "",
      sortable: true,
      width: "10rem",
      cell: (row) => groupInfoListById["" + row.osgroup] || "",
    },
    {
      name: systemalertstext.itemtype,
      selector: row => row.itemtype,
      sortable: true,
      width: "11rem",
      cell: (row) => row.itemtype,
    },
    {
      name: systemalertstext.itemid,
      selector: row => row.itemid,
      sortable: true,
      width: "10rem",
      cell: (row) => row.itemid,
    },
    {
      name: systemalertstext.alerttype,
      selector: row => row.alerttype,
      sortable: true,
      width: "11rem",
      cell: (row) => row.alerttype,
    },
    {
      name: systemalertstext.criticity,
      selector: row => row.criticity,
      sortable: true,
      width: "9rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => criticityData.find((x) => x.id == row.criticity)?.name || ""
    },
    {
      name: systemalertstext.value,
      selector: row => row.value,
      sortable: true,
      width: "10rem",
      cell: (row) => row.value,
    },
    {
      name: systemalertstext.acquited,
      key: "acquited",
      selector: row => row.acquitment ? row.acquitment.acquited : 'no',
      sortable: true,
      width: "7rem",
      cell: (row) => <div style={{ cursor: 'pointer' }} onClick={acquitment(row)}>
        {(row.acquitment?.acquited && row.acquitment.acquited === "yes") ? (
          <div>{systemalertstext.yes}</div>
        ) : (
          <div>{systemalertstext.no}</div>
        )}
      </div>
      ,
    },
    {
      name: systemalertstext.closed,
      selector: row => row.closed,
      sortable: true,
      width: "7rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => closedData.find((x) => x.id == row.closed)?.name || ""
    },
    {
      name: systemalertstext.comments,
      selector: row => row.comments ? row.comments.length : 0,
      sortable: true,
      cell: (row) => <div style={{ cursor: 'pointer' }} onClick={comment(row)}>{(row.comments && row.comments.length > 0) ? (row.comments.length + ' ' + systemalertstext.commentsvar) : systemalertstext.nocomments}</div>,
    },
    {
      name: "Actions",
      sortable: false,
      width: "6rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title={systemalertstext.deletealert}>
              <CustomDeleteButton
                deleteTitle={systemalertstext.deletealert}
                deleteSubTitle={systemalertstext.confirmdelete}
                handleSupprimer={deleteAlertFunction(row)}
              />
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  const handleClickCommentOpen = () => {
    setCommentOpen(true);
  };
  const handleClickCommentClose = () => {
    setCommentOpen(false);
  };
  const handleClickAcquitmentOpen = () => {
    setAcquitmentOpen(true);
  };
  const handleClickAcquitmentClose = () => {
    setAcquitmentOpen(false);
  };
  const comment = (row) => async () => {
    let obj = dataAlerts.find((o) => o.id === row.id);
    if (obj) {
      setCurrentAlert(obj);
      handleClickCommentOpen();
    }
  };
  const acquitment = (row) => async () => {
    let obj = dataAlerts.find((o) => o.id === row.id);
    if (obj) {
      setCurrentAlert(obj);
      handleClickAcquitmentOpen();
    }
  };

  const deleteAlertFunction = (row) => async () => {
    let obj = dataAlerts.find((o) => o.id === row.id);
    let idSelected = obj.id;
    axios
      .delete(deleteSystemAlert(idSelected),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        })
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success(systemalertstext.deleted);
          refetch();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const handleSelectedRowsChange = (selection) => {
    setAlerts(selection.selectedRows);
  };

  return (
    <>
      <div style={{ paddingTop: 10 }}>
        <DataTable
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          //title="Tableau d'alertes"
          noDataComponent={<NoData>{systemalertstext.noalerts}</NoData>}
          noHeader={true}
          columns={columns}
          persistTableHead
          pagination
          subHeader
          onSelectedRowsChange={handleSelectedRowsChange}
          selectableRows={true}
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          // expandOnRowClicked
          // expandableRowsComponent={ExpandableComponent}
          // expandableRowDisabled={(row) => row.disabled}
          paginationComponentOptions={{
            noRowsPerPage: false,
            rowsPerPageText: "Lignes par page",
            rangeSeparatorText: "sur",
            selectAllRowsItem: false,
            selectAllRowsItemText: "Selectionner toutes les lignes",
          }}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleClickCommentClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={commentOpen}
        >
          <CustomDialogTitle id="customized-dialog-title" onClose={handleClickCommentClose}>
            {systemalertstext.comments}
          </CustomDialogTitle>
          <DialogContent dividers>
            <CommentsDialog
              currentAlert={currentAlert}
              closeModal={handleClickCommentClose}
              refetch={refetch}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
        <Dialog
          onClose={handleClickAcquitmentClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={acquitmentOpen}
        >
          <CustomDialogTitle id="customized-dialog-title" onClose={handleClickAcquitmentClose}>
            {systemalertstext.acquitment}
          </CustomDialogTitle>
          <DialogContent dividers>
            <AcquitmentDialog
              currentAlert={currentAlert}
              closeModal={handleClickAcquitmentClose}
              refetch={refetch}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
        <NotificationContainer />
      </div>
    </>
  );
};

export default RTSystemAlerts;
